/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgEdiTranslate = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m6.7 22.7-1.4-1.4L6.6 20H2v-8h2v6h2.6l-1.3-1.3 1.4-1.4 3.7 3.7zM22 12H8V8H2V2h20zm-12-2h10V4H10zM4 6h4V4H4zm14 2h-6V6h6z"
      fill="currentcolor"
    />
  </Icon>
);
export { SvgEdiTranslate as EdiTranslate };
